import styled from "styled-components";
import { PriceDataContainer } from "../../health/health-price/price-data-style";

export const ForeignersHealthPriceContainer = styled(PriceDataContainer)``;
